import * as React from 'react';
import classnames from 'classnames'
import { Link } from 'office-ui-fabric-react/lib/Link';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { registerIcons } from 'office-ui-fabric-react/lib/Styling';
import { debug } from 'util';
import Debugger from '../components/Debugger';
import { getThemeMode, setThemeMode, ThemeMode } from '../theme';

// Inline SVGs because the fabric icon font subsets for Sunny/ClearNight/Contrast
// don't load reliably in the Outlook add-in webview
registerIcons({
    icons: {
        'mm-theme-system': (
            <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 3a9 9 0 0 1 0 18Z" fill="currentColor" stroke="none" />
            </svg>
        ),
        'mm-theme-light': (
            <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
            </svg>
        ),
        'mm-theme-dark': (
            <svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
            </svg>
        ),
    },
});

export interface Props {
    campaignID?: string,
    className: string,
    //links?: { [url: string]: string },
    account?: any,
    autoLogin?: (any, string) => string,
    onSignout?: () => void,
}

export const DEFAULT_ACCOUNT_LINKS = {
    "/campaigns/{campaignID}": "Open this campaign's dashboard",
    "/campaigns": "View all your campaigns",

}

export const DEFAULT_HELP_LINKS = {
    "https://mm365.me/tutorials": "View tutorials",
    "https://mm365.me/help": "Open help center",
}
export class State {
    debug: boolean;
    themeMode: ThemeMode;
}

const THEME_MODE_CYCLE: { [mode in ThemeMode]: ThemeMode } = {
    'system': 'light',
    'light': 'dark',
    'dark': 'system',
};

const THEME_MODE_ICONS: { [mode in ThemeMode]: string } = {
    'system': 'mm-theme-system',
    'light': 'mm-theme-light',
    'dark': 'mm-theme-dark',
};

const THEME_MODE_LABELS: { [mode in ThemeMode]: string } = {
    'system': 'System',
    'light': 'Light',
    'dark': 'Dark',
};

export default class Wrapper extends React.Component<Props, State> {


    constructor(props, context) {
        super(props, context);
        this.state = {
            debug: false,
            themeMode: getThemeMode(),
        };
    }

    onToggleDebug = (event) => {
        this.setState({
            debug: !this.state.debug
        });
    }

    onToggleTheme = () => {
        const themeMode = THEME_MODE_CYCLE[this.state.themeMode];
        setThemeMode(themeMode);
        this.setState({ themeMode });
    }


    render() {
        const {
            className,
            account,
            autoLogin,
            onSignout,
        } = this.props;

        const {
            debug,
            themeMode
        } = this.state;

        const nextThemeMode = THEME_MODE_CYCLE[themeMode];

        let links = account ? {
            ...DEFAULT_ACCOUNT_LINKS,
            "/account": "Manage your account",
            ...DEFAULT_HELP_LINKS
        } : DEFAULT_HELP_LINKS;



        return (
            <div className={classnames('mm-wrapper', className)}>
                <div className="-row -expand">
                    {this.props.children}
                </div>
                {debug && <div className="-row -expand">
                    <Debugger />
                </div>}
                <div className="-row" style={{ "paddingTop": "1em" }}>
                    {account &&
                        <React.Fragment>
                            <p className="ms-font-m -label -tightpadding"><span className="ms-fontWeight-bold">Account: {account.email}</span></p>
                            <p className="ms-font-s -label"><span className="">{account.plan}</span></p>
                        </React.Fragment>
                    }
                    {!account &&
                        <p className="ms-font-m -label"><span className="ms-fontWeight-semibold">MailMerge365 Links</span></p>}


                    <div className="mm-para">
                        <ul className="-links">
                            {Object.keys(links).filter(key => this.props.campaignID || key.indexOf('{campaignID}') < 0).map(key =>
                                <li key={key}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" href={account && autoLogin(account, key.replace('{campaignID}', this.props.campaignID))}>{links[key]}</Link></li>

                            )}
                            {onSignout &&
                                <li key={'signout'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" onClick={onSignout}>Sign out</Link></li>
                            }
                            {account && account.debug &&
                                <>
                                    <li key={'debug'}><i className="ms-Icon ms-Icon--ChevronRight" aria-hidden="true"></i> <Link target="_blank" onClick={this.onToggleDebug}>Debug</Link></li>
                                </>
                            }
                        </ul>
                    </div>
                </div>
                <div className="-themeToggle">
                    <TooltipHost content={`Theme: ${THEME_MODE_LABELS[themeMode]} — click to switch to ${THEME_MODE_LABELS[nextThemeMode]}`}>
                        <IconButton
                            iconProps={{ iconName: THEME_MODE_ICONS[themeMode] }}
                            ariaLabel={`Theme: ${THEME_MODE_LABELS[themeMode]}. Switch to ${THEME_MODE_LABELS[nextThemeMode]} theme`}
                            onClick={this.onToggleTheme}
                        />
                    </TooltipHost>
                </div>
            </div>
        );
    }
}
